export default __webpack_public_path__ + "locales/lv/SharingPanel.json?hash=66772f1f19ef19f1186fae72fa5da718";